import { render, staticRenderFns } from "./BranchDetails.vue?vue&type=template&id=31894ff4&scoped=true"
import script from "./BranchDetails.vue?vue&type=script&lang=js"
export * from "./BranchDetails.vue?vue&type=script&lang=js"
import style0 from "./BranchDetails.vue?vue&type=style&index=0&id=31894ff4&prod&lang=scss&scoped=true"
import style1 from "./BranchDetails.vue?vue&type=style&index=1&id=31894ff4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31894ff4",
  null
  
)

export default component.exports